export const COURT_TYPES = ["Choose", "HomeCourt", "Tennis", "Basketball", "Pickleball"];

export const ACCESSORIES = [
  { value: "Lights", field: "Accessories[Lights]", cls: "lights" },
  { value: "Basketball Net", field: "Accessories[Basketball Net]", cls: "net-basketball" },
  { value: "Hockey Net", field: "Accessories[Hockey Net]", cls: "net-hockey" },
  { value: "Volleyball Net", field: "Accessories[Volleyball Net]", cls: "net-volleyball" },
  { value: "Tennis Net", field: "Accessories[Tennis Net]", cls: "net-tennis" },
  { value: "Pickleball Net", field: "Accessories[Pickleball Net]", cls: "net-pickleball" },
];

const ALL_ACCESSORIES = ACCESSORIES.map((accessory) => accessory.value);

const COURT_RULES = {
  HomeCourt: {
    showKeyColor: true,
    allowedAccessories: ["Lights", "Basketball Net", "Hockey Net", "Volleyball Net"],
    sizes: {
      "50x100": {
        allowedAccessories: ["Lights", "Basketball Net", "Hockey Net", "Tennis Net"],
      },
    },
  },
  Tennis: {
    showKeyColor: false,
    allowedAccessories: ["Lights", "Tennis Net"],
  },
  Basketball: {
    showKeyColor: true,
    allowedAccessories: ["Lights", "Basketball Net"],
  },
  Pickleball: {
    showKeyColor: false,
    allowedAccessories: ["Lights", "Pickleball Net"],
  },
};

export function getCourtRules(courtType, courtSize) {
  const typeRules = COURT_RULES[courtType] ?? {};
  const sizeRules = typeRules.sizes?.[courtSize] ?? {};

  return {
    showKeyColor: sizeRules.showKeyColor ?? typeRules.showKeyColor ?? true,
    allowedAccessories: new Set(sizeRules.allowedAccessories ?? typeRules.allowedAccessories ?? ALL_ACCESSORIES),
  };
}
